export default "__VITE_ASSET__9011d64b__"